import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			alignItems: 'center',
		},
		dark: {
			color: theme.palette.scoreapp.dark,
			fontSize: theme.spacing(2),
			fontWeight: 700,
		},
		gray: {
			color: theme.palette.scoreapp.text,
			fontSize: theme.spacing(1.8),
			fontWeight: 500,
		},
		label: {
			paddingLeft: theme.spacing(1),
		},
	}),
	{
		name: 'OnlyVisible',
	},
)

export default useStyles
